import React from 'react';
import styled from 'styled-components';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { Container } from '../Grid';
import { gridGapSize } from '../lib/styles/helpers';
import MessageCard from './MessageCard';
import ScrollBox from '../ScrollBox';
import SwipeBox from '../SwipeBox';
import Loading from './Loading';

const messageGap = 8;

const MContainer = styled(Container)`
  margin-top: -${messageGap / 2}px;
  margin-bottom: -${messageGap / 2}px;
  padding-bottom: ${gridGapSize}px;
  padding-top: ${gridGapSize}px;
  overflow-x: hidden;
`;

const MessagesContainer = (props) => {
  return (
    <ScrollBox onScrollNear={props.getMoreMessages}>
      <MContainer>
        <ReactCSSTransitionGroup
          transitionName="message"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {props.messages.map(message =>
            <SwipeBox id={message.id} onSwiped={props.deleteMessage} key={message.id}>
              <MessageCard message={message} />
            </SwipeBox>)}
        </ReactCSSTransitionGroup>
        {props.loading &&
          <Loading />}
      </MContainer>
    </ScrollBox>
  );
};

export default MessagesContainer;



// WEBPACK FOOTER //
// ./src/Messages/MessagesContainer.js